import { DolozkaZlucitelnostiFormData }
  from '../../../../model/sprievodnyDokument/dolozkaZlucitelnosti/DolozkaZlucitelnostiFormData';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClientFetch } from '../../../../context/ClientStatusContext';
import getFormData from '../../../../function/getFormData';
import { zlucitelnostEnumFromNazov }
  from '../../../../model/sprievodnyDokument/dolozkaZlucitelnosti/ZlucitelnostSPravomEuEnum';
import { FormDataResponse } from '../../../../model/sprievodnyDokument/FormDataResponse';
import Uuid from '../../../../model/Uuid';

interface ReturnType {
  formDataResponse: FormDataResponse<DolozkaZlucitelnostiFormData>,
  formDataStatus: ClientStatus,
}

const map = (dolozkaZlucitelnosti: DolozkaZlucitelnostiFormData): DolozkaZlucitelnostiFormData => ({
  ...dolozkaZlucitelnosti,
  zlucitelnostSPravomEu: zlucitelnostEnumFromNazov(dolozkaZlucitelnosti?.zlucitelnostSPravomEu),
});

export default (
  type: string,
  year: number,
  index: number,
  stadiumUuid: Uuid,
): ReturnType => {
  const {
    data,
    status,
  } = useClientFetch(
    getFormData,
    [type, year, index, 'DolozkaZlucitelnosti', stadiumUuid],
    [],
  );
  return {
    formDataResponse: data ? {
      formData: map(data.formData as DolozkaZlucitelnostiFormData),
      materialDetail: data.materialDetail,
    } : null,
    formDataStatus: status,
  };
};
